import app from "./app";
import setting from "./setting";
/** Reducers */

export default {
  app,
  setting,
};
